export type Intent = "sa" | "ben" | "ln" | "ds";

export const isValidIntent = (intent: string | null): intent is Intent => {
  return (
    intent === "sa" || intent === "ben" || intent === "ln" || intent === "ds"
  );
};
